const Theme = {
  card_background_color: 'white',
  body_background_color: '#EDEDED',

  logo_image_url: 'fonderiehorne.png',
  header_full_height:true,

  token_url: 'fonderiehorne.svg',

  button_color: '#00AFAA',

  text_font: 'Montserrat',
  text_color: 'black',

  title_font: 'Montserrat',
  title_weight: 400,
  subtitle_font: 'Montserrat',

  popup_text_color: 'black',

  button_radius: 10,
  button_border_width:1,
}

export default Theme
